// OutsideSalesOpportunity. Mirrors data-component=
// "outside-sales-opportunity" from the approved HTML. Side card
// that surfaces a candidate barn/organization the customer is
// connected to but which has NOT been verified as a 100X customer.
// Verify-first before any Outside Sales outreach.
//
// TODO(runtime): hydrate from services/outside-sales.suggest and
// link View verification requirements to the Outside Sales
// qualification criteria once that read endpoint lands.
import type { ReactNode } from 'react';
import { HORSE_PORTRAIT_PLACEHOLDER } from '../../../data/mockData.js';
import type { OutsideSalesOpportunity as OutsideSalesOpportunityData } from '../mockData.js';

export interface OutsideSalesOpportunityProps {
  opportunity: OutsideSalesOpportunityData;
  photoUrl?: string;
  onViewRequirements?: () => void;
}

export function OutsideSalesOpportunity({
  opportunity,
  photoUrl,
  onViewRequirements,
}: OutsideSalesOpportunityProps): ReactNode {
  return (
    <section className="card" data-component="outside-sales-opportunity">
      <div className="section-heading">
        <h3>Outside Sales opportunity</h3>
        <span className="needs-pill">Verify first</span>
      </div>
      <div className="opportunity-photo">
        <img src={photoUrl ?? HORSE_PORTRAIT_PLACEHOLDER} alt="" />
      </div>
      <div className="horse-related">
        <strong>{opportunity.organizationName}</strong>
        <p>
          {opportunity.location} &middot; {opportunity.horsesReported} &middot;{' '}
          {opportunity.manager}
        </p>
        <div className="opportunity-grid">
          <div>
            <span>Relationship age</span>
            <b>{opportunity.relationshipAge}</b>
          </div>
          <div>
            <span>100X customers there</span>
            <b>{opportunity.customersThere}</b>
          </div>
          <div>
            <span>Program status</span>
            <b>{opportunity.programStatus}</b>
          </div>
        </div>
        <div className="relationship-callout">{opportunity.callout}</div>
        <button
          type="button"
          className="text-btn"
          onClick={onViewRequirements}
        >
          View verification requirements &rarr;
        </button>
      </div>
    </section>
  );
}
